import angular from 'angular';
import { prop, compose, includesIn } from 'micro-fp';

import templateUrl from './shiftTemplatePreviewComponent.html';

const STICK_TO_BOTTOM_THRESHOLD = 250;
const NOTES_ELLIPSIS_LENGTH = 100;

class ShiftTemplatePreviewCtrl {
  constructor(
    Authentication,
    AutomatedBreaksService,
    PersonaCollection,
    ShiftTasksService,
    TaskTemplatesService,
    Utils,
    sdk,
    $scope,
    $element,
    $window,
    $timeout
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AutomatedBreaksService,
      PersonaCollection,
      ShiftTasksService,
      TaskTemplatesService,
      Utils,
      sdk,
      $scope,
      $element,
      $window,
      $timeout,
    });
  }

  $onInit() {
    this.getShiftDurationMinutes = this.sdk('model-extensions/getShiftDurationMinutes');
    this.showTags = this.Authentication.isOrgFeatureEnabled('tags');
    this.showTaskTemplates =
      this.ShiftTasksService.isFeatureEnabled && this.ShiftTasksService.isFeatureTurnedOn;
    this.breaksEnabled = Boolean(this.Authentication.user.orgSettings.shiftBreakType);
    this.areAutomatedBreaksOn = this.AutomatedBreaksService.areAutomatedBreaksOn;
    this.watchLayout();
  }

  getDuration() {
    const durationInMinutes = this.getShiftDurationMinutes(this.template);
    const decimalFormat = this.Utils.getDecimalFormat();
    return this.Utils.getDisplayDuration(durationInMinutes, decimalFormat);
  }

  getTags() {
    return this.PersonaCollection.tags
      .filter(compose(includesIn(this.template.tagIds), prop('id')))
      .map(prop('name'))
      .sort()
      .join(' • ');
  }

  getTaskTemplates() {
    return this.template.taskTemplates
      ?.filter(({ deleted }) => !deleted)
      .map(prop('title'))
      .join(' • ');
  }

  getNotes() {
    if (this.template.summary?.length > NOTES_ELLIPSIS_LENGTH) {
      return `${this.template.summary.slice(0, NOTES_ELLIPSIS_LENGTH - 3)}...`;
    }

    return this.template.summary || '-';
  }

  watchLayout() {
    if (!this.scrollParent) {
      return;
    }

    const parent = this.$element.parent();

    const update = () => {
      const parentRect = parent[0].getBoundingClientRect();
      const stickToBottom =
        this.$window.innerHeight - parentRect.bottom < STICK_TO_BOTTOM_THRESHOLD;

      this.$element.css({
        position: 'fixed',
        ...(this.toRight
          ? {
              right: 'auto',
              left: `${parentRect.right}px`,
            }
          : {
              right: `${this.$window.document.documentElement.offsetWidth - parentRect.left}px`,
              left: 'auto',
            }),
        ...(stickToBottom
          ? {
              top: 'auto',
              bottom: `${this.$window.document.documentElement.offsetHeight - parentRect.bottom}px`,
            }
          : {
              top: `${parentRect.top - (this.offsetTop || 0)}px`,
              bottom: 'auto',
            }),
      });

      this.$element[stickToBottom ? 'addClass' : 'removeClass']('sticked-to-bottom');
    };

    this.$scope.$watch(() => this.$scope.$$postDigest(update));

    this.$timeout(update);
    this.scrollParent.on('scroll', update);
    const windowElement = angular.element(this.$window);
    windowElement.on('resize', update);
    this.$scope.$on('$destroy', () => {
      this.scrollParent.off('scroll', update);
      windowElement.off('resize', update);
    });
  }
}

export default {
  templateUrl,
  controllerAs: 'ctrl',
  controller: ShiftTemplatePreviewCtrl,
  bindings: {
    template: '<',
    scrollParent: '<',
    offsetTop: '<?',
    toRight: '<?',
  },
};
